const getters = {
  getAlerts: (state) => state.alerts,
  getMessages: (state) => state.messages.data,
  getMessagesPerPage: (state) => state.messages.perPage,
  getMessagesHasShowMore: (state) =>
    state.messages.chunked.filter((item) => item.length > 0).length > 0,
  getImmediateMessages: (state) => (cached) => {
    return state.immediateMessages.filter(
      (s) => !cached.includes(parseInt(s.messageId))
    );
  },
  getSchedule: (state) => {
    return state.schedule.length == 0 ? new Array() : state.schedule;
  },
  getAlertsDetails: (state) => {
    return state.alertsDetails.data;
  },
  getPaging: (state) => {
    return {
      ...state.alertsDetails.paging,
      totalRecords: state.alertsDetails.paging.totalItemCount,
      totalPages: state.alertsDetails.paging.pageCount,
      pageSize: state.alertsDetails.configPaginated.pageSize,
    };
  },
};

export default getters;
